// common.js (em migração do global.js)
// Constantes genéricas utilizadas em múltiplos módulos simples (ex: Áreas, Cargos, Colaboradores, etc)

/**
 * HELPER: DENORMALIZE
 * Transforma um ID e um mapa de Labels em um objeto { id, label }
 * ideal para persistência desnormalizada no Firestore.
 */
export const denormalize = (id, labelsMap) => {
    if (id === null || id === undefined) return null;
    return {
        id: id,
        label: labelsMap[id] || 'Não Informado'
    };
};

/**
 * HELPER PARA DROPDOWNS:
 * Gera automaticamente os Arrays requeridos pelo Input type="select"
 */
export const getOptionsFromMap = (keysObj, labelsObj) => {
    return Object.values(keysObj).map(id => ({
        value: id,
        label: labelsObj[id] || String(id)
    }));
};

export const GLOBAL_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive'
};

export const GLOBAL_STATUS_LABELS = {
    [GLOBAL_STATUS.ACTIVE]: 'Ativo',
    [GLOBAL_STATUS.INACTIVE]: 'Inativo'
};

export const GLOBAL_STATUS_OPTIONS = getOptionsFromMap(GLOBAL_STATUS, GLOBAL_STATUS_LABELS);
